export default __webpack_public_path__ + "static/media/shipment.ad31bf4e.svg";